export const schema = {
    month: {
        id: 'month',
        label: 'Mês',
        placeholder: '',
        type: 'select',
        value: '0',
        required: true,
    },
    year: {
        id: 'year',
        label: 'Ano',
        placeholder: '',
        type: 'select',
        value: '2017',
        required: true,
    },
    fileType: {
        id: 'fileType',
        label: 'Tipo de relatório',
        required: true,
        disabled: false,
        type: 'radio',
        value: '1',
        lookup: 'PDF',
        options: [
            {
                codigo: '1',
                nome: 'PDF',
            },
            {
                codigo: '2',
                nome: 'XML',
            },
        ],
    },
};
